import { settings } from "../../../customize/settings";
import { ITipoLotto } from "../../../interfaces/dettaglio/attributes/models";
import { IBaseError } from "../../../interfaces/errors";
import { IListResponse } from "../../../interfaces/rest";
import { getJWT } from "../../../lib/jwt";

const BASE_URL = `${settings.apiUrl}tipo-lotto`;

export const getTipoLotto = async (id: number): Promise<ITipoLotto> => {
	const url = `${BASE_URL}/${id}`;
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const jwt = getJWT();
	if (jwt) headers.append('Authorization', 'Bearer ' + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers: headers
	});
	const json: ITipoLotto | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as ITipoLotto;
}

export const getTipoLottoList = async (): Promise<IListResponse<ITipoLotto>> => {
	const url = `${BASE_URL}/list`;
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const jwt = getJWT();
	if (jwt) headers.append('Authorization', 'Bearer ' + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers: headers
	});
	const json: IListResponse<ITipoLotto> | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IListResponse<ITipoLotto>;
}
